(function ($) {
    'use strict';
    var details = {};

    var EDIT_CLAN_SELECTOR = '.js-edit-clan';
    var EDIT_CLAN_FORM_SELECTOR = '.js-edit-clan-form';
    var EDIT_CLAN_LINK_SELECTOR = '.js-edit-clan-link';
    var EDIT_CLAN_SAVE_SELECTOR = '.js-edit-clan-save';
    var CONFIRM_EDIT_VALIDATION_LIST_SELECTOR = '.js-confirm-edit-validation-list';
    var REQUEST_TO_JOIN_BUTTON_SELECTOR = '.js-request-join';
    var REQUEST_TO_JOIN_PENDING_SELECTOR = '.js-request-pending';
    var APPLICATION_ICON_SELECTOR = '[data-field="application-icon"] span';
    var INVITATION_ICON_SELECTOR = '[data-field="invitation-icon"] span';
    var RANK_ICON_SELECTOR = '[data-field="rank-icon"] span';

    var ROLENAME_COMMANDER = 'commander';
    var ROLENAME_EXECUTIVE_OFFICER = 'executive_officer';
    var ROLENAME_RECRUITMENT_OFFICER = 'recruitment_officer';
    var ROLENAME_STAFF_SERGEANT = 'staff_sergeant';
    var ROLENAME_SERGEANT = 'sergeant';
    var ROLENAME_CORPORAL = 'corporal';
    var ROLENAME_PRIVATE_FIRST_CLASS = 'private_first_class';
    var ROLENAME_PRIVATE = 'private';
    var role_ranks = {};
    role_ranks[ROLENAME_COMMANDER] = 7;
    role_ranks[ROLENAME_EXECUTIVE_OFFICER] = 6;
    role_ranks[ROLENAME_RECRUITMENT_OFFICER] = 5;
    role_ranks[ROLENAME_STAFF_SERGEANT] = 4;
    role_ranks[ROLENAME_SERGEANT] = 3;
    role_ranks[ROLENAME_CORPORAL] = 2;
    role_ranks[ROLENAME_PRIVATE_FIRST_CLASS] = 1;
    role_ranks[ROLENAME_PRIVATE] = 0;
    var $modal;

    var $form;
    var $nameField;
    var $tagField;
    var $recruitingPolicyField;
    var $editButton;
    var $saveButton;


    var showEditModal = function () {
        wg_errors.clearErrors();
        $form[0].reset();
        $form.find('.validationtext').removeClass('invalid').hide();
        validate();


        $modal = $(EDIT_CLAN_SELECTOR).showAsModal({
            dismissible: true
        });
        $nameField.focus();

    };

    var saveClanChanges = function () {
        var $this = $(this);
        if ($this.is(clans.FORMS_BUTTON_DISABLED_SELECTOR))
            return;

        var data = {
            'clan_id': c_id,
        };

        if (clans.isChanged($nameField, true))
            data.clan_name = $nameField.val();
        if (clans.isChanged($tagField, true))
            data.clan_tag = $tagField.val();
        if (clans.isChanged($recruitingPolicyField))
            data.clan_recruiting_policy = $recruitingPolicyField.filter(':checked').val();

        $modal.close();
        wg_modal.showThrobber();
        clans.callEndpoint({
            endpoint: 'edit_clan_details',
            data: data,
            success: null, // Default handler will redirect to new clan page or trigger reload
            failure: null // Use default handler for error message
        });

    };
    details.application_render = function () {
        var $item = $(this);

        $item.find(APPLICATION_ICON_SELECTOR).renderListBoxIcon(window.STATIC_URL + 'portal/img/svg-icons/clans/received.svg', gettext("application"));

        $item.addListBoxDropDown({
            'accept': {
                'title': gettext("Accept"),
                'handler': function ($item) {
                    (function (application_id) {
                        wg_modal.showThrobber();
                        clans.callEndpoint({
                            endpoint: 'approve_application',
                            data: {
                                'application_id': application_id
                            },
                            success: function () {
                                wg_ui.reload();
                            },
                            failure: null // Use default handler for error message
                        });
                    })($item.attr('data-id'));
                }
            },
            'reject': {
                'title': gettext("Reject"),
                'handler': function ($item) {
                    (function (application_id) {
                        wg_modal.showThrobber();
                        clans.callEndpoint({
                            endpoint: 'reject_application',
                            data: {
                                'application_id': application_id
                            },
                            success: function () {
                                $item.remove();
                                wg_modal.hideThrobber();
                            },
                            failure: null // Use default handler for error message
                        });
                    })($item.attr('data-id'));
                }
            }
        });
    };
    details.invites_render = function () {
        var $item = $(this);


        $item.find(INVITATION_ICON_SELECTOR).renderListBoxIcon(window.STATIC_URL + 'portal/img/svg-icons/clans/sent.svg', gettext('invitation'));

        $item.addListBoxDropDown({
            'rescind': {
                'title': gettext("Rescind"),
                'handler': function ($item) {
                    clans.callEndpoint({
                        endpoint: 'rescind_invite',
                        data: {
                            invite_id: $item.data('id')
                        },
                        success: function () {
                            $item.remove();
                        },
                        failure: null // Use default handler for error message
                    })
                }
            }
        });
    };

    details.members_render = function () {
        var $item = $(this);

        $item.find(RANK_ICON_SELECTOR).renderListBoxIcon(window.STATIC_URL + 'portal/img/svg-icons/clans/rank/' + $item.data('role-key') + '.svg', $item.data('role-name'));

        var current_id = currentUser && currentUser.account_id ? currentUser.account_id : null;
        var current_roleRank = currentUser && currentUser['role-rank'] ? currentUser['role-rank'] : null;
        var current_roleKey = currentUser && currentUser['role'] ? currentUser['role'] : null;
        var item_roleRank = parseInt($item.data('role-rank'));
        var item_roleKey = $item.data('role-key');
        var item_playerName = $item.find('[data-field="name"]').text();

        if (current_id != $item.data('account_id')) {
            if (item_roleRank < current_roleRank) {
                var availableOptions = {
                    kick: {
                        'title': gettext("Remove from Regiment") + '...',
                        'handler': function ($item) {
                            wg_modal.showConfirm(
                                gettext('Remove player?'),
                                gettext("Remove {player-name} from your regiment?").replace('{player-name}', item_playerName),
                                gettext("Remove"),
                                function () {
                                    (function ($item) {
                                        wg_modal.showThrobber();
                                        clans.callEndpoint({
                                            endpoint: 'remove_player',
                                            data: {
                                                clan_id: c_id,
                                                ids: $item.data('account_id')
                                            },
                                            success: function (data) {
                                                $item.remove();
                                                wg_modal.hideThrobber();
                                            },
                                            failure: null // Use default handler for error message
                                        });
                                    })($item);
                                });
                        }
                    },
                    promoteToCommander: {
                        'title': gettext('Promote to Commander') + '...',
                        'handler': function ($item) {
                            wg_modal.showConfirm(gettext('Promote to Commander'),
                                '<p>' + gettext('Promoting {user} to Commander will also demote you. <br/> Are you sure you want to promote {user} to Commander?').split('{user}').join($item.data('name')) + '</p>',
                                gettext('Promote'),
                                function () {
                                    editMember($item, ROLENAME_COMMANDER)
                                });
                        }
                    },
                    promoteToExecutiveOfficer: {
                        'title': gettext("Promote to Executive Officer"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_EXECUTIVE_OFFICER);
                        }
                    },
                    promoteToRecruitmentOfficer: {
                        'title': gettext("Promote to Recruitment Officer"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_RECRUITMENT_OFFICER);
                        }
                    },
                    demoteToRecruitmentOfficer: {
                        'title': gettext("Demote to Recruitment Officer"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_RECRUITMENT_OFFICER);
                        }
                    },
                    promoteToStaffSergeant: {
                        'title': gettext("Promote to Staff Sergeant"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_STAFF_SERGEANT);
                        }
                    },
                    demoteToStaffSergeant: {
                        'title': gettext("Demote to Staff Sergeant"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_STAFF_SERGEANT);
                        }
                    },
                    promoteToSergeant: {
                        'title': gettext("Promote to Sergeant"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_SERGEANT);
                        }
                    },
                    demoteToSergeant: {
                        'title': gettext("Demote to Sergeant"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_SERGEANT);
                        }
                    },
                    promoteToCorporal: {
                        'title': gettext("Promote to Corporal"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_CORPORAL);
                        }
                    },
                    demoteToCorporal: {
                        'title': gettext("Demote to Corporal"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_CORPORAL);
                        }
                    },
                    promoteToPrivateFirstClass: {
                        'title': gettext("Promote to Private First Class"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_PRIVATE_FIRST_CLASS);
                        }
                    },
                    demoteToPrivateFirstClass: {
                        'title': gettext("Demote to Private First Class"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_PRIVATE_FIRST_CLASS);
                        }
                    },
                    demoteToPrivate: {
                        'title': gettext("Demote to Private"),
                        'handler': function ($item) {
                            editMember($item, ROLENAME_PRIVATE);
                        }
                    }
                };
                var options = [];
                var actionItem;
                var key;

                if (item_roleRank < role_ranks[ROLENAME_COMMANDER] &&
                        current_roleKey === ROLENAME_COMMANDER) {
                    options['promoteToCommander'] = availableOptions.promoteToCommander;
                }
                if (item_roleRank < role_ranks[ROLENAME_EXECUTIVE_OFFICER]){
                    actionItem = availableOptions.promoteToExecutiveOfficer;
                    if (clans.executive_officers_count >= clans.MAX_EXECUTIVE_OFFICERS)
                        $.extend(actionItem, {
                            disabled: true,
                            tooltip: gettext('Maximum number of executive officers: {max}').replace('{max}', clans.MAX_EXECUTIVE_OFFICERS)
                        });
                    options['promoteToExecutiveOfficer'] = actionItem;
                }

                if (item_roleRank != role_ranks[ROLENAME_RECRUITMENT_OFFICER]){
                    if (item_roleRank < role_ranks[ROLENAME_RECRUITMENT_OFFICER]){
                        actionItem = availableOptions.promoteToRecruitmentOfficer;
                        key = 'promoteToRecruitmentOfficer';
                    } else {
                        actionItem = availableOptions.demoteToRecruitmentOfficer;
                        key = 'demoteToRecruitmentOfficer';
                    }
                    if (clans.recruitment_officers_count >= clans.MAX_RECRUITMENT_OFFICERS)
                        $.extend(actionItem, {
                            disabled: true,
                            tooltip: gettext('Maximum number of recruitment officers: {max}').replace('{max}', clans.MAX_RECRUITMENT_OFFICERS)
                        });
                    options[key] = actionItem;
                }

                if (item_roleRank < role_ranks[ROLENAME_STAFF_SERGEANT]){
                    options['promoteToStaffSergeant'] = availableOptions.promoteToStaffSergeant;
                } else if (item_roleRank > role_ranks[ROLENAME_STAFF_SERGEANT]){
                    options['demoteToStaffSergeant'] = availableOptions.demoteToStaffSergeant;
                }

                if (item_roleRank < role_ranks[ROLENAME_SERGEANT]){
                    options['promoteToSergeant'] = availableOptions.promoteToSergeant;
                } else if (item_roleRank > role_ranks[ROLENAME_SERGEANT]){
                    options['demoteToSergeant'] = availableOptions.demoteToSergeant;
                }

                if (item_roleRank < role_ranks[ROLENAME_CORPORAL]){
                    options['promoteToCorporal'] = availableOptions.promoteToCorporal;
                } else if (item_roleRank > role_ranks[ROLENAME_CORPORAL]){
                    options['demoteToCorporal'] = availableOptions.demoteToCorporal;
                }

                if (item_roleRank < role_ranks[ROLENAME_PRIVATE_FIRST_CLASS]){
                    options['promoteToPrivateFirstClass'] = availableOptions.promoteToPrivateFirstClass;
                } else if (item_roleRank > role_ranks[ROLENAME_PRIVATE_FIRST_CLASS]){
                    options['demoteToPrivateFirstClass'] = availableOptions.demoteToPrivateFirstClass;
                }

                if (item_roleRank < role_ranks[ROLENAME_PRIVATE]){
                    options['promoteToPrivate'] = availableOptions.promoteToPrivate;
                } else if (item_roleRank > role_ranks[ROLENAME_PRIVATE]){
                    options['demoteToPrivate'] = availableOptions.demoteToPrivate;
                }

                if (current_roleKey != ROLENAME_RECRUITMENT_OFFICER)
                    options['kick'] = availableOptions.kick;

                if (Object.keys(options).length > 0)
                    $item.addListBoxDropDown(options);
            }
        }
    };

    var editMember = function ($item, newRole) {
        wg_modal.showThrobber();
        clans.callEndpoint({
            endpoint: 'change_role',
            data: {
                clan_id: c_id,
                ids: $item.data('account_id'),
                newRole: newRole
            },
            success: function (data) {
                wg_ui.reload();
            },
            failure: null // Use default handler for error message
        });
    };

    var disbandClan = function () {
        var title = gettext('Disband Regiment?'),
            desc = '<p>' + gettext('Please confirm you wish to disband your regiment. All members will be removed. This action can not be reversed.') + '</p>',
            verb = gettext('Disband');

        wg_modal.showConfirm(title, desc, verb, function () {
            wg_modal.showThrobber();

            clans.callEndpoint({
                endpoint: 'disband',
                data: {
                    'clan_id': c_id
                },
                success: null, // Default handler will redirect to overview
                failure: null // Use default handler for error message
            });
        });
    };
    var leaveClan = function () {
        var $this = $(this);
        if (!$this.is(clans.FORMS_BUTTON_DISABLED_SELECTOR)) {
            var clanName = window.clan_info.clan.name;
            wg_modal.showConfirm(
                gettext('Leave Regiment?'),
                '<p>' + gettext('Are you sure you want to leave {clanname}?')
                    .replace('{clanname}', clanName) + '</p>',
                gettext('Leave'),
                function () {
                    var account_ids = (currentUser && currentUser.account_id) ? currentUser.account_id : null;
                    if (account_ids) {
                        wg_modal.showThrobber();
                        clans.callEndpoint({
                            endpoint: 'leave_clan',
                            data: {
                                'clan_id': c_id,
                                'account_ids': account_ids
                            },
                            success: function () {
                                wg_ui.reload();
                            },
                            failure: null // Use default handler for error message
                        });
                    }
                });
        }
    };
    var validate = function () {
        var $validationList = $saveButton.find(CONFIRM_EDIT_VALIDATION_LIST_SELECTOR);
        var $tagChangedValidationMessage = $('.js-clans_tag_validation__tagchanged');

        $validationList.empty();
        window.tooltipReset();

        var valid = clans.validateClan($validationList, $nameField, $tagField, $recruitingPolicyField).children().length == 0;

        var nameChanged = clans.isChanged($nameField, true);
        var tagChanged = clans.isChanged($tagField);
        var recruitingPolicyChanged = clans.isChanged($recruitingPolicyField);

        var isChanged = (nameChanged || tagChanged || recruitingPolicyChanged);

        if (!isChanged)
            $validationList.append($('<li>').text(gettext('At least one value must be changed')));

        $tagChangedValidationMessage.toggle(valid && tagChanged);

        valid = valid && (isChanged);

        $saveButton.toggleClass(clans.FORMS_BUTTON_DISABLED_CLASS, !valid);
        $saveButton.toggleClass('js-mobile-tooltip', !valid);

        return valid;
    };

    $(function () {
        $('.js-request-join').on('click tap', function () {
            wg_modal.showThrobber();
            clans.callEndpoint({
                endpoint: 'send_applications',
                data: {
                    clan_id: c_id
                },
                success: function () {
                    $(REQUEST_TO_JOIN_BUTTON_SELECTOR).hide();
                    $(REQUEST_TO_JOIN_PENDING_SELECTOR).show();
                    wg_modal.hideThrobber();

                },
                failure: null // Use default handler for error message
            })
        });
        $('.js-clan-disband').on('click tap', disbandClan);
        $('.js-clan-leave-confirm').on('click tap', leaveClan);
        $('.js-clan-leave').on('click tap', leaveClan);

        $form = $(EDIT_CLAN_FORM_SELECTOR);
        if ($form.length == 0)
            return; // Not the clan leader so the form wasnt rendered and none of this validation can be done

        $nameField = $(clans.getFormFieldSelector('name'));
        $tagField = $(clans.getFormFieldSelector('tag'));
        $recruitingPolicyField = $(clans.getFormFieldSelector('recruiting_policy'));
        $editButton = $(EDIT_CLAN_LINK_SELECTOR);
        $saveButton = $(EDIT_CLAN_SAVE_SELECTOR);
        $editButton.on('click tap', showEditModal);


        $nameField.on('input propertychange validated', validate);
        $tagField.on('input propertychange validated', validate);
        $saveButton.on('click tap', saveClanChanges);
        $recruitingPolicyField.on('click tap', function () {
            validate();
        });
        validate();

    });

    window.details = details;
})(jQuery);
